import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TERMS_CONTENT } from "./legal-content";
import usePageMeta from "../hooks/usePageMeta";

export default function Terms() {
  usePageMeta({
    title: "Terms of Use — AiPresidential",
    description: "Terms of Use for AiPresidential.com and the AiPresidential trilogy by Victor M. Medina.",
    path: "/terms",
  });
  return (
    <div className="min-h-screen bg-[var(--void)] text-gray-200">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 mb-8 text-sm font-orbitron tracking-widest uppercase"
          data-testid="terms-back-home"
        >
          <ArrowLeft className="w-4 h-4" /> Back Home
        </Link>
        <h1 className="font-orbitron text-4xl md:text-5xl font-bold gradient-text mb-8" data-testid="terms-title">
          Terms of Use
        </h1>
        <LegalBody content={TERMS_CONTENT} testidPrefix="terms" />
      </div>
    </div>
  );
}

export function LegalBody({ content, testidPrefix }) {
  return (
    <div className="space-y-6 leading-relaxed text-sm md:text-base">
      <p className="text-gray-500 text-xs md:text-sm uppercase tracking-widest" data-testid={`${testidPrefix}-effective`}>
        Effective Date: {content.effective}
      </p>
      {content.sections.map((s, i) => (
        <section key={s.heading} data-testid={`${testidPrefix}-section-${i}`}>
          <h2 className="font-orbitron text-lg md:text-xl text-white mb-2">{s.heading}</h2>
          {s.paragraphs.map((p, j) => (
            <p key={j} className="text-gray-400 mb-3 whitespace-pre-line">{p}</p>
          ))}
        </section>
      ))}
    </div>
  );
}
